// Dawn-style <product-form> custom element adapted for Concocina (no modules)
(function () {
  const utils = window.themeCartUtils || {};
  const routes = (window.routes = window.routes || utils.routes || {
    cart_add_url: '/cart/add.js',
    cart_change_url: '/cart/change.js',
    cart_update_url: '/cart/update.js'
  });

  const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    cartError: 'cart-error'
  };

  function updateHeaderCountFromSections(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    try {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sections['cart-icon-bubble'];
      const bubble = tempDiv.querySelector('[data-cart-count]');
      if (!bubble) return;
      const text = (bubble.textContent || '').trim();
      const count = text === '99+' ? 99 : parseInt(text, 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = text;
        el.style.display = count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  function publish(eventName, detail) {
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"][name="add"]');
      this.submitButtonText = this.submitButton
        ? this.submitButton.querySelector('span') || this.submitButton
        : null;
      this.errorMessageWrapper = this.querySelector('[data-product-form-error]');

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }

    async getCurrentVariantQuantityInCart(variantId) {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      let total = 0;
      (cart.items || []).forEach((item) => {
        if (item.variant_id === Number(variantId)) total += item.quantity;
      });
      return total;
    }

    showPartialAddMessage(amountAdded) {
      if (!this.errorMessageWrapper) return;
      const msg = `Debido a la disponibilidad, solo se añadieron ${amountAdded} artículos al carrito.`;
      this.errorMessageWrapper.textContent = msg;
      this.errorMessageWrapper.hidden = false;
    }

    showMaxReachedMessage() {
      if (!this.errorMessageWrapper) return;
      const msg = 'Tu carrito ya tiene la cantidad máxima de este artículo.';
      this.errorMessageWrapper.textContent = msg;
      this.errorMessageWrapper.hidden = false;
    }

    performAddToCart(quantity) {
      const formData = new FormData(this.form);
      formData.set('quantity', String(quantity));

      const sections = this.getSectionsToRender().map((s) => s.section);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((state) => {
          const status = state && state.status;
          if (typeof status === 'number' && status >= 400) {
            throw state;
          }
          // Preserve how many units were actually requested to be added
          // so the notification can show the delta, not the line total.
          state.addedQuantity = quantity;

          updateHeaderCountFromSections(state.sections);

          publish(PUB_SUB_EVENTS.cartUpdate, { cartData: state });
          this.renderSections(state);
          this.handleCartSurface(state);
        })
        .catch((error) => {
          this.handleErrorMessage(error);
          publish(PUB_SUB_EVENTS.cartError, { error });
        })
        .finally(() => {
          this.setLoading(false);
        });
    }

    onSubmitHandler(event) {
      const submitter = event.submitter || this.submitButton;
      if (!submitter) return;

      const isAdd =
        submitter.name === 'add' ||
        submitter.classList.contains('product-page__sticky-btn') ||
        submitter.classList.contains('main-workshop__cta') ||
        submitter.classList.contains('giftcard-main__cta');

      if (!isAdd) return;

      event.preventDefault();
      this.handleErrorMessage();
      this.setLoading(true);

      const qtyInput = this.form.querySelector('input[name="quantity"]');
      let requested = Number(qtyInput?.value || '1');
      if (!requested || requested < 1) requested = 1;

      const variantId = this.dataset.variantId;
      const stock = Number(this.dataset.inventoryQuantity || '0');
      const policy = this.dataset.inventoryPolicy || 'deny';

      // If continue selling or no stock information, default to normal behavior
      if (policy === 'continue' || !stock) {
        this.performAddToCart(requested);
        return;
      }

      this.getCurrentVariantQuantityInCart(variantId)
        .then((inCart) => {
          const remaining = stock - inCart;

          if (remaining <= 0) {
            // Cart already at max for this variant
            this.showMaxReachedMessage();
            this.setLoading(false);
            return;
          }

          let toAdd = requested;
          if (requested > remaining) {
            toAdd = remaining;
            this.showPartialAddMessage(toAdd);
          }

          this.performAddToCart(toAdd);
        })
        .catch(() => {
          // If /cart.js fails, fallback to normal add
          this.performAddToCart(requested);
        });
    }

    getSectionsToRender() {
      return [
        {
          section: 'main-cart',
          selector: '#main-cart'
        },
        {
          section: 'cart-live-region-text',
          selector: '#cart-live-region-text'
        },
        {
          section: 'cart-icon-bubble',
          selector: '.cart-icon-bubble'
        },
        {
          section: 'cart-drawer',
          selector: '#CartDrawer-Section'
        }
      ];
    }

    renderSections(parsedState) {
      if (!parsedState || !parsedState.sections) return;
      this.getSectionsToRender().forEach(({ section, selector }) => {
        const container = document.querySelector(selector);
        if (!container) return;
        const html = parsedState.sections[section];
        if (!html) return;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const replacement =
          tempDiv.querySelector(selector) || tempDiv.firstElementChild;
        if (replacement) {
          container.replaceWith(replacement);
        } else {
          container.innerHTML = html;
        }
      });
    }

    handleCartSurface(parsedState) {
      const surface = (window.themeCart && window.themeCart.surface) || 'drawer';
      if (surface === 'drawer') {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(parsedState);
          if (typeof drawer.open === 'function') {
            drawer.open();
          }
        }
      }

      // Ensure legacy drawer + header badge also stay in sync while
      // ConcocinaCart is still present.
      if (
        window.ConcocinaCart &&
        typeof window.ConcocinaCart.renderDrawerFromCart === 'function'
      ) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((res) => res.json())
          .then((cart) => {
            window.ConcocinaCart.renderDrawerFromCart(cart);
          })
          .catch(() => {});
      }
    }

    setLoading(isLoading) {
      if (!this.submitButton) return;
      this.submitButton.disabled = isLoading;
      this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    handleErrorMessage(error = null) {
      if (!this.errorMessageWrapper) return;
      let message = '';
      if (error && typeof error === 'object') {
        if (error.message) message = error.message;
        if (error.description) message = error.description;
        if (!message && error.status === 422 && error.errors) {
          message = error.errors.join(', ');
        }
        if (!message) {
          message =
            this.getAttribute('data-default-error') ||
            'No se pudo agregar al carrito. Intenta nuevamente.';
        }
      }

      if (!error) {
        // Clear any previous error
        this.errorMessageWrapper.textContent = '';
        this.errorMessageWrapper.hidden = true;
        return;
      }

      this.errorMessageWrapper.textContent = message;
      this.errorMessageWrapper.hidden = !message;
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
})();

